import React, { useEffect } from 'react';
import { Alert, Button } from 'antd';
import { refreshGeoConfig, useGeoConfig } from './config';
export default function GeoConfigNotice() {
  const {reloadRequired} = useGeoConfig();
  useEffect(() => {
    const refresh = () => { if(document.visibilityState === 'visible') refreshGeoConfig(true); };
    const timer = setInterval(refresh, 60000);
    window.addEventListener('focus',refresh);
    return () => { clearInterval(timer); window.removeEventListener('focus',refresh); };
  }, []);
  return reloadRequired ? <Alert banner type="info" message="Cambió la configuración del mapa. Guarda tu trabajo y recarga para aplicarla."
    action={<Button onClick={()=>window.location.reload()}>Recargar</Button>} /> : null;
}
